import React, {
  useState,
  useCallback,
  useMemo
} from 'react';
import TabPanel, { Item } from 'devextreme-react/tab-panel';

import { formatMessage } from 'devextreme/localization';
import styles from './adminTabList.module.scss';
import UserAdmin from '../ResponsiblePerson/UserAdmin';
import UserRole from '../ResponsiblePerson/UserRole';
import PieceAdmin from './PieceAdmin';
import MessagesAdmin from './MessagesAdmin';
import MailingAdmin from './MailingAdmin';
import ActsAdmin from './ActsAdmin';
import ContractsAdmin from './ContractsAdmin';

const AdminTabList = ({
  plantId
}) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const onSelectionChanged = useCallback(({
    name,
    value
  }) => {
    if (name === 'selectedIndex') {
      setSelectedIndex(value);
    }
  }, []);
  const itemTitleRender = useCallback((item) => (
    <span>{item.name}</span>
  ), []);

  const pieceAdmin = useMemo(() => () => (
    <PieceAdmin plantId={plantId} />
  ), [plantId]);

  const userAdmin = useMemo(() => () => (
    <UserAdmin selectedIndex={selectedIndex} />
  ), [selectedIndex]);

  const userRole = useMemo(() => () => (
    <UserRole selectedIndex={selectedIndex} />
  ), [selectedIndex]);

  const messagesAdmin = useMemo(() => () => (
    <MessagesAdmin selectedIndex={selectedIndex} plantId={plantId} />
  ), [selectedIndex, plantId]);

  const mailingAdmin = useMemo(() => () => (
    <MailingAdmin plantId={selectedIndex} />
  ), [selectedIndex]);

  const actsAdmin = useMemo(() => () => (
    <ActsAdmin plantId={selectedIndex} />
  ), [selectedIndex]);

  const contractsAdmin = useMemo(() => () => (
    <ContractsAdmin selectedIndex={selectedIndex} />
  ), [selectedIndex]);

  return (
    <>
      <div className={styles.containing}>
        <TabPanel selectedIndex={selectedIndex}
                    onOptionChanged={onSelectionChanged}
                    itemTitleRender={itemTitleRender}
                    elementAttr={{ class: styles.tabs }}
          >
          <Item tabComponent={() => (<span>{formatMessage('administrationTabs').tabs.userAdmin}</span>)}
                  render={userAdmin}
            />
          <Item tabComponent={() => (<span>{formatMessage('administrationTabs').tabs.userRole}</span>)}
                render={userRole}
          />
          <Item tabComponent={() => (<span>{formatMessage('administrationTabs').tabs.pieces}</span>)}
                  render={pieceAdmin}
            />
          <Item tabComponent={() => (<span>{formatMessage('administrationTabs').tabs.messages}</span>)}
                  render={messagesAdmin}
            />
          <Item tabComponent={() => (<span>{formatMessage('administrationTabs').tabs.mailing}</span>)}
                  render={mailingAdmin}
            />
          <Item tabComponent={() => (<span>{formatMessage('administrationTabs').tabs.acts}</span>)}
                  render={actsAdmin}
            />
          <Item tabComponent={() => (<span>{formatMessage('administrationTabs').tabs.contracts}</span>)}
                  render={contractsAdmin}
            />
        </TabPanel>
      </div>
    </>
  );
};

export default React.memo(AdminTabList);
